import { render, staticRenderFns } from "./OblykCarousel.vue?vue&type=template&id=d836557e"
import script from "./OblykCarousel.vue?vue&type=script&lang=js"
export * from "./OblykCarousel.vue?vue&type=script&lang=js"
import style0 from "./OblykCarousel.vue?vue&type=style&index=0&id=d836557e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports